module.exports = __webpack_public_path__ + "img/idx-sport-title.248afaf.webp";